import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ClientProfile } from '@syfo/types/api.client.types';

/**
 * Check authentication status and fetch user profile
 * Returns user profile if authenticated, null otherwise
 */
export const checkAuthThunk = createAsyncThunk<ClientProfile | null>(
  'auth/checkAuth',
  async () => {
    console.log('[Auth] Checking authentication status...');
    
    try {
      const response = await fetch('/api/me');
      
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const data: ClientProfile = await response.json();
          return data;
        } else {
          // [Auth] User is not authenticated (no JSON response)
          return null;
        }
      } else {
        // [Auth] User is not authenticated (response not OK)
        return null;
      }
    } catch {
      // Silently fail auth check in local development (endpoint doesn't exist locally)
      return null;
    }
  }
);
